import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { t } from '@/lib/i18n'

function upsertMeta(
  attr: 'name' | 'property',
  key: string,
  content: string,
) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function cleanDuplicateDescriptions(content: string) {
  document
    .querySelectorAll('meta[name="description"][data-hid="description"]')
    .forEach((tag) => tag.remove())

  const remaining = document.querySelectorAll('meta[name="description"]')
  if (remaining.length === 0) {
    upsertMeta('name', 'description', content)
  } else {
    remaining.forEach((tag, index) => {
      if (index === 0) (tag as HTMLMetaElement).content = content
      else tag.remove()
    })
  }
}

export function useAuthMeta() {
  const route = useRoute()

  function applyMeta() {
    const routeName = String(route.name || '')
    let title = 'Coral Club'
    let description: string | null = null

    if (routeName === 'index' || routeName.startsWith('index')) {
      title = t('LOGIN_META_TITLE', 'Coral Club')
      description = t('LOGIN_META_DESCRIPTION', '')
    } else if (routeName === 'registration') {
      title = t('REGISTRATION_META_TITLE', 'Coral Club')
      description = t('REGISTRATION_META_DESCRIPTION', '')
    } else if (
      routeName === 'activate'
      || routeName === 'activate-create'
      || routeName === 'activate-success'
    ) {
      title = t('Registration_ActivationCoralID', 'Coral Club')
      description = t('Registration_Description', '')
    } else if (routeName === 'activate-linkSending') {
      title = t('Registration_ForgotPassword', 'Coral Club')
      description = t('Registration_Description', '')
    }

    document.title = title

    if (description) {
      upsertMeta('name', 'description', description)
      upsertMeta('property', 'og:title', title)
      upsertMeta('property', 'og:description', description)
      cleanDuplicateDescriptions(description)
    }
  }

  watch(() => route.name, applyMeta, { immediate: true })

  return { applyMeta }
}
